(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ebd-browse-media"] && !Shopify.designMode) return;
  try {
    (() => {
  const ready = image => {
    if (!image.matches?.('.ebd-photo-back')) return;
    image.closest('.has-back')?.classList.toggle('back-ready', image.complete && image.naturalWidth > 0);
  };
  document.addEventListener('load', event => ready(event.target), true);
  document.addEventListener('error', event => ready(event.target), true);
  const initialize = () => document.querySelectorAll('.ebd-photo-back').forEach(ready);
  initialize();
  document.addEventListener('DOMContentLoaded', initialize, { once: true });
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ebd-collection-filter-bar"] && !Shopify.designMode) return;
  try {
    (()=>{
 const initialize=()=>document.querySelectorAll('.ebd-refined-collection').forEach(form=>{
  if(form.dataset.filtersReady)return;form.dataset.filtersReady='true';
  form.querySelectorAll('.ebd-filter-size .ebd-filter-options').forEach(options=>{
   const merged=new Map();
   [...options.querySelectorAll('.ebd-filter-choice')].forEach(choice=>{
    const input=choice.querySelector('input'),label=choice.querySelector('span');
    const normalized=label.textContent.trim().replace(/[~–—]/g,'-').replace(/\s+/g,' ').toUpperCase();
    const key=input.name+'|'+normalized;const previous=merged.get(key);
    choice.querySelector('small')?.remove();
    label.textContent=normalized.replace(/-/g,'–');
    if(previous){
     const primary=previous.querySelector('input[type="checkbox"]');
     primary.checked=primary.checked||input.checked;
     primary.disabled=primary.disabled&&input.disabled&&!primary.checked;
     input.type='hidden';input.disabled=!primary.checked;previous.appendChild(input);
     primary.addEventListener('change',()=>{input.disabled=!primary.checked;});
     previous.querySelectorAll('input[type="hidden"]').forEach(alias=>{alias.disabled=!primary.checked;});
     choice.remove();
    }else{merged.set(key,choice);}
   });
   const selected=[...merged.values()].filter(choice=>choice.querySelector('input[type="checkbox"]').checked);
   const badge=options.closest('.ebd-filter-group').querySelector('.ebd-filter-number');if(badge){badge.textContent=String(selected.length);badge.removeAttribute('aria-label');}
   selected.forEach(choice=>{
    const inputs=[...choice.querySelectorAll('input')];if(inputs.length<2)return;
    const name=inputs[0].name,aliases=inputs.map(input=>input.value),current=new URL(location.href),active=current.searchParams.getAll(name);
    const links=[...form.querySelectorAll('.ebd-active-filters a')].filter(link=>{const remaining=new URL(link.href).searchParams.getAll(name);return aliases.some(value=>active.includes(value)&&!remaining.includes(value));});
    if(!links.length)return;
    const keep=active.filter(value=>!aliases.includes(value));current.searchParams.delete(name);current.searchParams.delete('page');keep.forEach(value=>current.searchParams.append(name,value));
    const accessible=links[0].querySelector('.ebd-sr')?.cloneNode(true);links[0].href=current.href;links[0].textContent=choice.querySelector('span').textContent+' ×';if(accessible)links[0].appendChild(accessible);links.slice(1).forEach(link=>link.remove());
   });
   const rank=text=>{const numeric=text.match(/^\d+(?:\.\d+)?(?=\s|$)/);if(numeric)return Number(numeric[0]);const size=text.split(/[ (]/)[0];const ranks={XXS:100,XS:101,S:102,M:103,L:104,XL:105,'2X':106,XXL:106,'2XL':106,'3X':107,XXXL:107,'3XL':107,'4X':108,'4XL':108,'5X':109,'5XL':109};return ranks[size]??200;};
   [...merged.values()].sort((a,b)=>rank(a.querySelector('span').textContent)-rank(b.querySelector('span').textContent)||a.textContent.localeCompare(b.textContent,undefined,{numeric:true})).forEach(choice=>options.appendChild(choice));
  });
  const groups=[...form.querySelectorAll('.ebd-filter-group')];
  groups.forEach(group=>{group.addEventListener('toggle',()=>{if(group.open)groups.forEach(other=>{if(other!==group)other.open=false;});});group.addEventListener('keydown',event=>{if(event.key==='Escape'){group.open=false;group.querySelector('summary').focus();}});});
  document.addEventListener('click',event=>{groups.forEach(group=>{if(group.open&&!group.contains(event.target))group.open=false;});});
  form.addEventListener('submit',event=>{
   event.preventDefault();const url=new URL(location.href);[...url.searchParams.keys()].forEach(key=>{if(key.startsWith('filter.')||key==='page'||key==='sort_by')url.searchParams.delete(key);});
   for(const [name,value] of new FormData(form)){if(value!=='')url.searchParams.append(name,value);}
   url.hash='';location.assign(url.href);
  });
  form.querySelector('select[name="sort_by"]')?.addEventListener('change',()=>form.requestSubmit());
 });
 initialize();document.addEventListener('shopify:section:load',initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ebd-editorial-announcements"] && !Shopify.designMode) return;
  try {
    (()=>{
  const banner=document.querySelector('.eh-banner');
  if(!banner)return;
  const slides=Array.from(banner.querySelectorAll('.eh-banner-slide'));
  const area=banner.querySelector('.eh-banner-slides');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  let current=0,timer,hovered=false;
  const show=next=>{slides[current].hidden=true;current=(next+slides.length)%slides.length;slides[current].hidden=false;};
  const schedule=()=>{clearInterval(timer);if(!reduced.matches&&!hovered&&!document.hidden&&!banner.contains(document.activeElement))timer=setInterval(()=>show(current+1),7000);};
  banner.querySelector('.eh-banner-prev').addEventListener('click',()=>{area.setAttribute('aria-live','polite');show(current-1);schedule();});
  banner.querySelector('.eh-banner-next').addEventListener('click',()=>{area.setAttribute('aria-live','polite');show(current+1);schedule();});
  banner.addEventListener('mouseenter',()=>{hovered=true;schedule();});
  banner.addEventListener('mouseleave',()=>{hovered=false;schedule();});
  banner.addEventListener('focusin',schedule);
  banner.addEventListener('focusout',()=>setTimeout(()=>{area.setAttribute('aria-live','off');schedule();},0));
  document.addEventListener('visibilitychange',schedule);
  reduced.addEventListener('change',schedule);
  schedule();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ebd-editorial-header"] && !Shopify.designMode) return;
  try {
    (()=>{const dialogs=document.querySelectorAll('.eh-dialog');document.querySelectorAll('[data-eh-open]').forEach(button=>button.addEventListener('click',()=>{const dialog=document.getElementById(button.dataset.ehOpen);if(!dialog)return;dialog.showModal();document.body.classList.add('eh-dialog-open');if(dialog.id==='eh-search')dialog.querySelector('input[type="search"]').focus({preventScroll:true});else dialog.querySelector('[data-eh-close]').focus({preventScroll:true});}));dialogs.forEach(dialog=>{dialog.querySelector('[data-eh-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target.closest('a[href]'))dialog.close();if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});dialog.addEventListener('close',()=>document.body.classList.remove('eh-dialog-open'));});const menus=document.querySelectorAll('.eh-nav-details');menus.forEach(menu=>menu.addEventListener('toggle',()=>{if(menu.open)menus.forEach(other=>{if(other!==menu)other.open=false;});}));document.addEventListener('click',event=>{if(!event.target.closest('.eh-nav-details')||event.target.closest('.eh-nav-details a[href]'))menus.forEach(menu=>menu.open=false);});document.addEventListener('keydown',event=>{if(event.key==='Escape')menus.forEach(menu=>menu.open=false);});})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ebd-home-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eb-home-review-cards')) {
    customElements.define('eb-home-review-cards', class extends HTMLElement {
      connectedCallback() {
        this.prepareCards();
        this.observer = new MutationObserver(() => this.prepareCards());
        this.observer.observe(this, { childList: true, subtree: true });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
      prepareCards() {
        this.querySelectorAll('.jdgm-carousel-item').forEach(card => {
          const stamp = card.querySelector('.jdgm-carousel-item__timestamp');
          const parts = stamp?.dataset.time?.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
          if (parts) {
            const date = new Date(Date.UTC(Number(parts[3]), Number(parts[1]) - 1, Number(parts[2])));
            const time = document.createElement('time');
            time.dateTime = date.toISOString().slice(0, 10);
            time.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }).format(date);
            if (stamp.textContent !== time.textContent) stamp.replaceChildren(time);
          }
          if (card.dataset.ebReviewReady) return;
          card.dataset.ebReviewReady = 'true';
          const image = card.querySelector('.jdgm-carousel-item__product-image');
          if (image && !card.classList.contains('jdgm--shop-review')) {
            const caption = document.createElement('p');
            caption.className = 'eb-home-review-product';
            caption.textContent = image.alt;
            image.parentElement.append(caption);
          } else if (card.classList.contains('jdgm--shop-review')) {
            const label = document.createElement('span');
            label.className = 'eb-home-review-label';
            label.textContent = this.dataset.storeLabel;
            card.querySelector('.jdgm-carousel-item__review')?.prepend(label);
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ebd-product-payments"] && !Shopify.designMode) return;
  try {
    (()=>{
 const setup=()=>document.querySelectorAll('.ebd-payment-options').forEach(options=>{
  if(options.dataset.ready)return;
  options.dataset.ready='true';
  const dialog=options.nextElementSibling;
  if(!dialog?.matches('.ebd-payment-dialog'))return;
  let opener;
  options.querySelectorAll('[data-payment-open]').forEach(button=>button.addEventListener('click',()=>{opener=button;dialog.showModal();}));
  dialog.querySelectorAll('[data-payment-close]').forEach(button=>button.addEventListener('click',()=>dialog.close()));
  dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();});
  dialog.addEventListener('close',()=>opener?.focus());
 });
 setup();document.addEventListener('shopify:section:load',setup);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ebd-product-recommendations"] && !Shopify.designMode) return;
  try {
    (()=>{const section=document.querySelector('[data-complementary-url]');if(!section||section.dataset.bundlePriority==='true')return;new IntersectionObserver((entries,observer)=>{if(!entries[0].isIntersecting)return;observer.disconnect();fetch(section.dataset.complementaryUrl).then(r=>{if(!r.ok)throw new Error('recommendations');return r.text();}).then(text=>{const content=new DOMParser().parseFromString(text,'text/html').querySelector('[data-ebd-complementary-results]');if(!content||!content.querySelector('.ebdxsell-card'))return;const featured=new Set(Array.from(document.querySelectorAll('.ebd-october-picks [data-cart-pick]')).map(card=>card.dataset.cartPick));const fresh=Array.from(content.children).filter(card=>{const link=card.querySelector('a[href]');const handle=link?new URL(link.href,location.origin).pathname.split('/').pop():'';return link&&handle!==section.dataset.includedGift&&!featured.has(handle);});if(!fresh.length)return;const clog=section.querySelector('[data-clog-feature]');const cards=fresh.filter(card=>!clog||card.querySelector('a[href]')?.getAttribute('href')!==clog.querySelector('a[href]').getAttribute('href'));section.querySelector('.ebdxsell-row').replaceChildren(...(clog?[clog,...cards.slice(0,3)]:cards.slice(0,4)));section.querySelector('h2').textContent=section.dataset.complementaryTitle;let note=section.querySelector('.ebd-recommend-note');if(!note){note=document.createElement('p');note.className='ebd-recommend-note';section.querySelector('h2').after(note);}note.textContent=section.dataset.complementaryNote;}).catch(()=>{});},{rootMargin:'300px'}).observe(section);})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ebd-ug-showcase"] && !Shopify.designMode) return;
  try {
    (() => {
  function mountShowcases(root) {
    root.querySelectorAll('[data-eu-showcase]').forEach((section) => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      section.querySelectorAll('[data-eu-scene]').forEach((button) => button.addEventListener('click', () => {
        section.querySelectorAll('[data-eu-scene]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        section.querySelectorAll('[data-eu-panel]').forEach((panel) => { panel.hidden = panel.dataset.euPanel !== button.dataset.euScene; });
        section.querySelectorAll('[data-eu-description]').forEach((copy) => { copy.hidden = copy.dataset.euDescription !== button.dataset.euScene; });
      }));
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => entries.forEach((entry) => { section.dataset.inView = String(entry.isIntersecting); }), { threshold: .12 });
        observer.observe(section);
      }
    });
  }
  mountShowcases(document);
  document.addEventListener('shopify:section:load', (event) => mountShowcases(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ebd-unseen-product"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-ug-product]').forEach(function(root){root.querySelectorAll('[data-ug-photo]').forEach(function(button){button.addEventListener('click',function(){root.querySelectorAll('.ug-photo').forEach(function(photo){photo.hidden=photo.id!==button.dataset.ugPhoto;});root.querySelectorAll('[data-ug-photo]').forEach(function(other){other.setAttribute('aria-pressed',String(other===button));});});});});
  } catch(e) { console.error(e); }
})();

})();
